import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withBranchHOC from "../Hoc/BranchHOC";
import { BranchDashboard } from "./BranchDashboard";
import { Modal } from "react-bootstrap";
import {
  getApplicationProperty,
  getGlobalVault,
  setInSessionJointApplicant,
} from "../Components/JointApplicant/Actions/JointApplicantAction";
import {
  HTTP_STATUS,
  S_APPLICANT_ID,
  S_CURRENT_MEMBER_ID,
  S_CURRENT_MEMBER_IN_MARKETPLACE,
  S_CURRENT_MEMBER_NAME,
} from "../Communication/Constants";
import {
  getActiveProduct,
  searchCategoryInCompleteList,
} from "../Utils/CommonUtilities";
import { goToNextStep, isNewMember } from "../Utils/LogicUtilities";
import {
  getProductFromVault,
  updateProductToVault,
} from "../Components/MarketPlace/Action/MarketPlaceAction";
import { getProductTemplate } from "../Redux/Actions/ProductTemplateActions";
import * as ROUTES from "../Constants/Routes";
import {
  addFundAmount,
  addFundMethod,
  storeFundProduct,
} from "../Components/FundingAmount/Action/FundAction";
import {
  doAccountCreate,
  doAccountSearch,
} from "../Redux/Actions/AccountSearchAction";
import { doApplicationSearch } from "../Redux/Actions/ApplicationSearchAction";
import STRINGS from "../Constants/Strings";
import {
  deleteApplication,
  getOccupationCodes,
  resetApplication,
} from "../Redux/Actions/ApplicationAction";
import updateApplicantData from "../Redux/Actions/UpdateApplicantAction";
import { getFileList, uploadFile } from "../Redux/Actions/FileManagementAction";
import {
  addDocument,
  deleteDocument,
  getDocumentList,
  getDocument,
} from "../Components/Documents/Actions/DocumentAction";
import {
  getEmployerPositionCodes,
  getIncomeSourcesList,
  getStatusList,
} from "../Components/EmploymentAndIncome/Actions/EmploymentAndIncomeAction";
import {
  doGetIdType,
  getVault,
} from "../Components/AboutYou/Actions/AboutYouActions";
import {
  getAccountPurposeList,
  getIndicateWhoList,
} from "../Components/Compliance/Actions/ComplianceActions";
import { getProductInformation } from "../Redux/Actions/ProductInformationAction";
import {
  getApplicationNotes,
  updateApplicationNotesReview,
} from "../Redux/Actions/ApplicationNotesAction";
import { doConfirmApplication } from "../Components/ConfirmAccountCreate/Actions/ConfirmAccountCreateAction";

class BranchDashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log(
      "componentDidMount",
      sessionStorage.getItem(S_CURRENT_MEMBER_ID)
    );
    const {
      updateMemberName,
      doStoreFundProduct,
      doAddFundMethod,
      doAddFundAmount,
    } = this.props;
    updateMemberName(null);
    doStoreFundProduct({});
    doAddFundMethod("");
    doAddFundAmount("");
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("componentDidUpdate", prevProps, prevState, snapshot);
    const {
      employmentAndIncomeReducer,
      getStatusList,
      getIncomeSourcesList,
      getEmployerPositionCodes,
      getOccupationCodes,
      idTypes,
      doGetIdType,
      complianceReducer,
      doGetIndicateWhoList,
      doGetAccountPurposeList,
      occupationCodes,
    } = this.props;
    if (employmentAndIncomeReducer.statusList.length === 0) {
      getStatusList();
    }
    if (employmentAndIncomeReducer.incomeSourcesList.length === 0) {
      getIncomeSourcesList();
    }
    if (employmentAndIncomeReducer.employerPositionCodes.length === 0) {
      getEmployerPositionCodes();
    }
    if (occupationCodes.length === 0) {
      getOccupationCodes();
    }
    if (idTypes.length === 0) {
      doGetIdType();
    }
    if (complianceReducer.indicateWhoList.length === 0) {
      doGetIndicateWhoList();
    }
    if (complianceReducer.accountPurposeList.length === 0) {
      doGetAccountPurposeList();
    }
  }

  proceedWithApplication = (bankingType, callback) => {
    const {
      history,
      doGetProductFromVault,
      applicantData,
      doGetProductTemplate,
      processTemplate,
      finInfo,
      productList,
      applicationCompleteList,
      updateMemberName,
      switchBanking,
    } = this.props;
    doGetProductFromVault((getProductFromVaultResponse) => {
      if (
        getProductFromVaultResponse &&
        getProductFromVaultResponse.status === HTTP_STATUS.OK
      ) {
        if (
          getProductFromVaultResponse.data &&
          getProductFromVaultResponse.data.length !== 0
        ) {
          const vaultProductList = getProductFromVaultResponse.data;
          const activeProduct = getActiveProduct(vaultProductList, bankingType);
          console.log(
            "active product",
            activeProduct,
            switchBanking,
            applicantData,
            isNewMember(applicantData)
          );
          if (activeProduct?.applicantId) {
            sessionStorage.setItem(S_APPLICANT_ID, activeProduct?.applicantId);
          }
          switchBanking(bankingType);
          let requireProductMissing = false;
          sessionStorage.setItem(S_CURRENT_MEMBER_IN_MARKETPLACE, "true");
          if (activeProduct && activeProduct.applicationStep?.componentName) {
            if (processTemplate?.flow.length === 0) {
              doGetProductTemplate((res) => {
                goToNextStep(
                  vaultProductList,
                  callback,
                  doGetProductTemplate,
                  history,
                  applicantData,
                  finInfo
                );
              }, vaultProductList[0]);
            } else {
              goToNextStep(
                vaultProductList,
                callback,
                doGetProductTemplate,
                history,
                applicantData,
                finInfo
              );
            }
          } else {
            history.push(`${ROUTES.VAULT_DASHBOARD}?marketplace`);
          }
        }
      }
    });
  };

  render() {
    const {
      finInfo,
      doGetGlobalVault,
      history,
      productList,
      updateMemberName: doUpdateMemberName,
      switchBanking,
      provinceList,
      doSetInSessionJointApplicant,
      doAccountSearch,
      doApplicationSearch,
      doResetApplication,
      doUpdateApplicant,
      doDeleteApplication,
      doUpdateProductToVault,
      doFileList,
      doUploadFile,
      doAddDocument,
      doDeleteDocument,
      doGetDocumentList,
      doGetDocument,
      doGetApplicationProperty,
      employmentAndIncomeReducer,
      occupationCodes,
      idTypes,
      doAccountCreate,
      complianceReducer,
      doGetProductInformation,
      doGetApplicationNotes,
      doUpdateApplicationNotesReview,
      doConfirmApp,
      doGetProductFromVault,
      doGetVault,
    } = this.props;
    return (
      <>
        <BranchDashboard
          finInfo={finInfo}
          doGetGlobalVault={doGetGlobalVault}
          history={history}
          proceedWithApplication={this.proceedWithApplication}
          productList={productList}
          updateMemberName={doUpdateMemberName}
          switchBanking={switchBanking}
          provinceList={provinceList}
          doSetInSessionJointApplicant={doSetInSessionJointApplicant}
          doAccountSearch={doAccountSearch}
          doApplicationSearch={doApplicationSearch}
          doResetApplication={doResetApplication}
          doUpdateApplicant={doUpdateApplicant}
          doDeleteApplication={doDeleteApplication}
          doUpdateProductToVault={doUpdateProductToVault}
          doFileList={doFileList}
          doUploadFile={doUploadFile}
          doAddDocument={doAddDocument}
          doDeleteDocument={doDeleteDocument}
          doGetDocumentList={doGetDocumentList}
          doGetDocument={doGetDocument}
          doGetApplicationProperty={doGetApplicationProperty}
          employmentAndIncomeReducer={employmentAndIncomeReducer}
          occupationCodes={occupationCodes}
          idTypes={idTypes}
          doAccountCreate={doAccountCreate}
          complianceReducer={complianceReducer}
          doGetProductInformation={doGetProductInformation}
          doGetApplicationNotes={doGetApplicationNotes}
          doUpdateApplicationNotesReview={doUpdateApplicationNotesReview}
          doConfirmApp={doConfirmApp}
          doGetProductFromVault={doGetProductFromVault}
          doGetVault={doGetVault}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      doGetGlobalVault: getGlobalVault,
      doGetProductFromVault: getProductFromVault,
      doUpdateProductToVault: updateProductToVault,
      doGetProductTemplate: getProductTemplate,
      doSetInSessionJointApplicant: setInSessionJointApplicant,
      doStoreFundProduct: storeFundProduct,
      doAddFundMethod: addFundMethod,
      doAddFundAmount: addFundAmount,
      doAccountSearch: doAccountSearch,
      doApplicationSearch: doApplicationSearch,
      doResetApplication: resetApplication,
      doUpdateApplicant: updateApplicantData,
      doDeleteApplication: deleteApplication,
      doFileList: getFileList,
      doUploadFile: uploadFile,
      doAddDocument: addDocument,
      doDeleteDocument: deleteDocument,
      doGetDocumentList: getDocumentList,
      doGetDocument: getDocument,
      doGetApplicationProperty: getApplicationProperty,
      getStatusList: getStatusList,
      getIncomeSourcesList: getIncomeSourcesList,
      getEmployerPositionCodes: getEmployerPositionCodes,
      getOccupationCodes: getOccupationCodes,
      doGetIdType: doGetIdType,
      doAccountCreate: doAccountCreate,
      doGetIndicateWhoList: getIndicateWhoList,
      doGetAccountPurposeList: getAccountPurposeList,
      doGetProductInformation: getProductInformation,
      doGetApplicationNotes: getApplicationNotes,
      doUpdateApplicationNotesReview: updateApplicationNotesReview,
      doConfirmApp: doConfirmApplication,
      doGetVault: getVault,
    },
    dispatch
  );
};

const mapStateToProps = (state) => ({
  finInfo: state.MarketplaceReducer.finInfo,
  applicantData: state.ApplicationReducer.response,
  processTemplate: state.ApplicationReducer.processTemplate,
  productList: state.MarketplaceReducer.productList,
  applicationCompleteList: state.ApplicationReducer.applicationCompleteList,
  provinceList: state.AboutYouReducer.provinceList,
  employmentAndIncomeReducer: state.EmploymentAndIncomeReducer,
  occupationCodes: state.ApplicationReducer.occupationCodes,
  idTypes: state.AboutYouReducer.idTypes,
  complianceReducer: state.ComplianceReducer,
});

BranchDashboardContainer.propTypes = {};

BranchDashboardContainer.defaultProps = {};

const BranchDashboardContainerWithConnect = withBranchHOC(
  BranchDashboardContainer
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchDashboardContainerWithConnect);
